import Vue from "vue";
import Router from "vue-router";
import Routes from "./h5";
import Main from "@/components/Main";
import SolutionEducation from "@/components/SolutionEducation";
import SolutionFinance from "@/components/SolutionFinance";
import SolutionIndustry from "@/components/SolutionIndustry";
import PortalAI from "@/components/PortalAI";
import PortalLM from "@/components/PortalLM";
import PortalLmAes from "@/components/PortalLmAes";
import PortalEdu from "@/components/PortalEdu";
import PortalIndustry from "@/components/PortalIndustry";
import PortalMCE from "@/components/PortalMCE";
import PortalPCS from "@/components/PortalPCS";
import PortalSRE from "@/components/PortalSRE";
import More from "@/components/More";
import Introduction from "@/components/Introduction";
import Terms from "@/components/Terms";
import Privacy from "@/components/Privacy";
import Progress from "@/components/Progress";
import JoinUs from "@/components/JoinUs";
import ContactUs from "@/components/ContactUs";
import ContactUsNew from "@/components/ContactUsNew";
import News from "@/components/News";
import Price from "@/components/Price";
import TermBegins from "@/components/TermBegins";
import ThanksGiving from "@/components/ThanksGiving";
// import AI from "@/page/pc/index";

Vue.use(Router);


const totalRoutes = [{
    path: "/",
    name: "Main",
    component: Main
  },
  {
    path: "/solution/education",
    name: "SolutionEducation",
    component: SolutionEducation
  },
  {
    path: "/solution/finance",
    name: "SolutionFinance",
    component: SolutionFinance
  },
  {
    path: "/solution/industry",
    name: "SolutionIndustry",
    component: SolutionIndustry
  },
  {
    path: "/solution",
    redirect: "/"
  },
  {
    path: "/portal/ai",
    name: "PortalAI",
    component: PortalAI
  },
  {
    path: "/portal/edu",
    name: "PortalEdu",
    component: PortalEdu
  },
  {
    path: "/portal/lm",
    name: "PortalLM",
    component: PortalLM
  },
  {
    path: "/portal/lmaes",
    name: "PortalLmAes",
    component: PortalLmAes
  },
  {
    path: "/portal/industry",
    name: "PortalIndustry",
    component: PortalIndustry
  },
  {
    path: "/portal/mce",
    name: "PortalMCE",
    component: PortalMCE
  },
  {
    path: "/portal/pcs",
    name: "PortalPCS",
    component: PortalPCS
  },
  {
    path: "/portal/sre",
    name: "PortalSRE",
    component: PortalSRE
  },
  {
    path: "/portal",
    redirect: "/"
  },
  {
    path: "/news",
    name: "News",
    component: News
  },
  {
    path: "/introduction",
    component: Introduction
  },
  {
    path: "/contact-us-new",
    component: ContactUsNew
  },
  {
    path: "/more",
    redirect: "/more/introduction",
    name: "More",
    component: More,
    children: [
      {
        path: "terms-of-service",
        component: Terms
      },
      {
        path: "privacy-policy",
        component: Privacy
      },
      {
        path: "progress",
        component: Progress
      },
      {
        path: "join-us",
        component: JoinUs
      },
      {
        path: "contact-us",
        component: ContactUs
      },
      {
        path: "introduction",
        component: Introduction
      },
    ]
  },
  {
    path: "/price",
    name: "Price",
    component: Price
  },
  {
    path: "/term-begins-activity",
    name: "TermBegins",
    component: TermBegins
  },
  {
    path: "/thanks-giving-activity",
    name: "ThanksGiving",
    component: ThanksGiving
  },
  {
    path: "/ai",
    name: "ai",
    component: PortalAI
  },
  ...Routes
];

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
  routes: totalRoutes
});

// 判断PC or mobile
router.beforeEach((to, from, next) => {
  let browserRedirect = function() {
    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    var bIsAndroid = sUserAgent.match(/android/i) == "android";
    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (
      bIsIpad ||
      bIsIphoneOs ||
      bIsMidp ||
      bIsUc7 ||
      bIsUc ||
      bIsAndroid ||
      bIsCE ||
      bIsWM
    ) {
      return false;
    } else {
      return true;
    }
  };
  let path = to.path;
  let dest = path;
  if (browserRedirect()) {
    // 去除pc下/h5开头路径
    if (path.startsWith("/h5")) {
      dest = path.replace(/^\/h5/i, "");
      dest = dest.padStart(1, "/");
    }
    // 判断是否找到pc页面,否则使用h5页面
    console.log(dest)
    if (totalRoutes.findIndex(item => item.path === dest) === -1) {
      dest = path;
    }
  } else {
    // 添加mobile下/h5开头
    if (!path.startsWith("/h5")) {
      dest = "/h5" + path;
      dest = dest.endsWith("/") ? dest.slice(0, -1) : dest;
      // 判断是否找到h5页面,否则使用pc页面
      if (totalRoutes.findIndex(item => item.path === dest) === -1) {
        dest = path;
      }
    }
  }
  dest === path ? next() : next({
    path: dest
  })

});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js